import * as yup from "yup";
import { Company } from "@/model/Company/Company";

const NewOrganisationModalValidation = (companies: Company[]) => {
	const externalIds = companies.map((x) => x.ExternalId)
		.filter((x) => x !== "");

	return yup.object().shape({
		Name: yup.string().required().min(2),
		ExternalId: yup.string().required().min(2).notOneOf(externalIds).test(
			'external_id',
			"External Id should not contain any spaces",
			(externalId) => {
				return !externalId.includes(" ");
			}
		),
		Language: yup.string().oneOf(["en", "no", "pt"]),
		Timezone: yup.string().required("Timezone is required"),
		Modules: yup.object().shape({
			IsCompetenceActive: yup.bool().required(),
			IsLabActive: yup.bool().required(),
			IsMaterialHandlingActive: yup.bool().required(),
			IsProceduresActive: yup.bool().required(),
			IsShiftActive: yup.bool().required(),
			IsTaskActive: yup.bool().required(),
		}),
		ActiveDirectoryGroups: yup.object().shape({
			Guest: yup.string().uuid(),
			Standard: yup.string().uuid(),
			Supervisor: yup.string().uuid(),
			Administrator: yup.string().uuid(),
		})
	});
}

export default NewOrganisationModalValidation;